import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useParams,
  Navigate,
} from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import UserDashboard from "./pages/UserDashboard";
import CreateKandiPage from "./pages/CreateKandiPage";
import ScanKandiPage from "./pages/ScanKandiPage";
import Navbar from "./components/Navbar";
import BottomNav from "./components/BottomNav";
import KandiProfile from "./components/KandiProfile";
import AboutPage from "./pages/AboutPage";
import FriendsPage from "./pages/FriendsPage";
import MapPage from "./pages/MapPage";
import ContactPage from "./pages/ContactPage";
import PublicProfilePage from "./pages/PublicProfilePage";
import StorePage from "./pages/StorePage";
import EventsPage from "./pages/EventsPage";

// Protected Route Component
function ProtectedRoute({ children }) {
  const user = localStorage.getItem("user");
  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <Router>
      <Navbar />
      <BottomNav />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<LandingPage theme="house" />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/store" element={<StorePage />} />
        <Route path="/events" element={<EventsPage />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <UserDashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path="/create"
          element={
            <ProtectedRoute>
              <CreateKandiPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/scan"
          element={
            <ProtectedRoute>
              <ScanKandiPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/friends"
          element={
            <ProtectedRoute>
              <FriendsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/map"
          element={
            <ProtectedRoute>
              <MapPage />
            </ProtectedRoute>
          }
        />

        {/* Legacy routes */}
        <Route path="/profile" element={<Navigate to="/dashboard" />} />
        <Route path="/collection" element={<Navigate to="/dashboard" />} />

        {/* Kandi profile page */}
        <Route path="/kandi/:id" element={<KandiProfileWrapper />} />

        {/* Public user profile — no auth required; privacy gates handle access */}
        <Route path="/user/:username" element={<PublicProfilePage />} />
      </Routes>
    </Router>
  );
}
function KandiProfileWrapper() {
  const { id } = useParams();
  return <KandiProfile kandiId={id} />;
}
export default App;
